import type { Category } from "../types/Category";

// 지출 카테고리
export const expenseCategories: Category[] = [
  // 식비
  {
    id: "cat_food",
    name: "식비",
    type: "expense",
    level: "major",
    parentId: null,
    icon: "🍚",
    sortOrder: 1,
    isDefault: true,
    isActive: true,
    children: [
      {
        id: "cat_food_meal",
        name: "식사",
        type: "expense",
        level: "minor",
        parentId: "cat_food",
        icon: "🍱",
        sortOrder: 1,
        isDefault: true,
        isActive: true,
      },
      {
        id: "cat_food_cafe",
        name: "카페",
        type: "expense",
        level: "minor",
        parentId: "cat_food",
        icon: "☕",
        sortOrder: 2,
        isDefault: true,
        isActive: true,
      },
      {
        id: "cat_food_grocery",
        name: "식재료",
        type: "expense",
        level: "minor",
        parentId: "cat_food",
        icon: "🥬",
        sortOrder: 3,
        isDefault: true,
        isActive: true,
      },
      {
        id: "cat_food_delivery",
        name: "배달",
        type: "expense",
        level: "minor",
        parentId: "cat_food",
        icon: "🛵",
        sortOrder: 4,
        isDefault: true,
        isActive: true,
      },
      {
        id: "cat_food_snack",
        name: "간식",
        type: "expense",
        level: "minor",
        parentId: "cat_food",
        icon: "🍪",
        sortOrder: 5,
        isDefault: true,
        isActive: true,
      },
    ],
  },
  // 교통
  {
    id: "cat_transport",
    name: "교통",
    type: "expense",
    level: "major",
    parentId: null,
    icon: "🚗",
    sortOrder: 2,
    isDefault: true,
    isActive: true,
    children: [
      {
        id: "cat_transport_public",
        name: "대중교통",
        type: "expense",
        level: "minor",
        parentId: "cat_transport",
        icon: "🚇",
        sortOrder: 1,
        isDefault: true,
        isActive: true,
      },
      {
        id: "cat_transport_taxi",
        name: "택시",
        type: "expense",
        level: "minor",
        parentId: "cat_transport",
        icon: "🚕",
        sortOrder: 2,
        isDefault: true,
        isActive: true,
      },
      {
        id: "cat_transport_fuel",
        name: "주유",
        type: "expense",
        level: "minor",
        parentId: "cat_transport",
        icon: "⛽",
        sortOrder: 3,
        isDefault: true,
        isActive: true,
      },
      {
        id: "cat_transport_parking",
        name: "주차",
        type: "expense",
        level: "minor",
        parentId: "cat_transport",
        icon: "🅿️",
        sortOrder: 4,
        isDefault: true,
        isActive: true,
      },
      {
        id: "cat_transport_car",
        name: "자동차유지비",
        type: "expense",
        level: "minor",
        parentId: "cat_transport",
        icon: "🔧",
        sortOrder: 5,
        isDefault: true,
        isActive: true,
      },
      {
        // defaultCategories와 동일하게 유지한다.
        // 어긋나면 Mock에서만 보이거나 실서버에만 있는 카테고리가 생겨
        // 개발 중 확인한 화면과 실제 화면이 달라진다.
        id: "cat_transport_toll",
        name: "통행료",
        type: "expense",
        level: "minor",
        parentId: "cat_transport",
        icon: "🛣️",
        sortOrder: 6,
        isDefault: true,
        isActive: true,
      },
    ],
  },
  // 쇼핑
  {
    id: "cat_shopping",
    name: "쇼핑",
    type: "expense",
    level: "major",
    parentId: null,
    icon: "🛍️",
    sortOrder: 3,
    isDefault: true,
    isActive: true,
    children: [
      {
        id: "cat_shopping_clothes",
        name: "옷",
        type: "expense",
        level: "minor",
        parentId: "cat_shopping",
        icon: "👕",
        sortOrder: 1,
        isDefault: true,
        isActive: true,
      },
      {
        id: "cat_shopping_cosmetics",
        name: "화장품",
        type: "expense",
        level: "minor",
        parentId: "cat_shopping",
        icon: "💄",
        sortOrder: 2,
        isDefault: true,
        isActive: true,
      },
      {
        id: "cat_shopping_living",
        name: "생활용품",
        type: "expense",
        level: "minor",
        parentId: "cat_shopping",
        icon: "🧴",
        sortOrder: 3,
        isDefault: true,
        isActive: true,
      },
      {
        id: "cat_shopping_electronics",
        name: "전자기기",
        type: "expense",
        level: "minor",
        parentId: "cat_shopping",
        icon: "📱",
        sortOrder: 4,
        isDefault: true,
        isActive: true,
      },
      {
        id: "cat_shopping_furniture",
        name: "가구",
        type: "expense",
        level: "minor",
        parentId: "cat_shopping",
        icon: "🪑",
        sortOrder: 5,
        isDefault: true,
        isActive: true,
      },
    ],
  },
  // 주거
  {
    id: "cat_housing",
    name: "주거",
    type: "expense",
    level: "major",
    parentId: null,
    icon: "🏠",
    sortOrder: 4,
    isDefault: true,
    isActive: true,
    children: [
      {
        id: "cat_housing_rent",
        name: "월세",
        type: "expense",
        level: "minor",
        parentId: "cat_housing",
        icon: "🔑",
        sortOrder: 1,
        isDefault: true,
        isActive: true,
      },
      {
        id: "cat_housing_maintenance",
        name: "관리비",
        type: "expense",
        level: "minor",
        parentId: "cat_housing",
        icon: "🏢",
        sortOrder: 2,
        isDefault: true,
        isActive: true,
      },
      {
        id: "cat_housing_utility",
        name: "공과금",
        type: "expense",
        level: "minor",
        parentId: "cat_housing",
        icon: "💡",
        sortOrder: 3,
        isDefault: true,
        isActive: true,
      },
      {
        id: "cat_housing_telecom",
        name: "인터넷/통신",
        type: "expense",
        level: "minor",
        parentId: "cat_housing",
        icon: "📶",
        sortOrder: 4,
        isDefault: true,
        isActive: true,
      },
    ],
  },
  // 의료
  {
    id: "cat_medical",
    name: "의료",
    type: "expense",
    level: "major",
    parentId: null,
    icon: "🏥",
    sortOrder: 5,
    isDefault: true,
    isActive: true,
    children: [
      {
        id: "cat_medical_hospital",
        name: "병원",
        type: "expense",
        level: "minor",
        parentId: "cat_medical",
        icon: "👨‍⚕️",
        sortOrder: 1,
        isDefault: true,
        isActive: true,
      },
      {
        id: "cat_medical_pharmacy",
        name: "약국",
        type: "expense",
        level: "minor",
        parentId: "cat_medical",
        icon: "💊",
        sortOrder: 2,
        isDefault: true,
        isActive: true,
      },
      {
        id: "cat_medical_checkup",
        name: "건강검진",
        type: "expense",
        level: "minor",
        parentId: "cat_medical",
        icon: "🩺",
        sortOrder: 3,
        isDefault: true,
        isActive: true,
      },
    ],
  },
  // 여가
  {
    id: "cat_leisure",
    name: "여가",
    type: "expense",
    level: "major",
    parentId: null,
    icon: "🎭",
    sortOrder: 6,
    isDefault: true,
    isActive: true,
    children: [
      {
        id: "cat_leisure_movie",
        name: "영화",
        type: "expense",
        level: "minor",
        parentId: "cat_leisure",
        icon: "🎬",
        sortOrder: 1,
        isDefault: true,
        isActive: true,
      },
      {
        id: "cat_leisure_travel",
        name: "여행",
        type: "expense",
        level: "minor",
        parentId: "cat_leisure",
        icon: "✈️",
        sortOrder: 2,
        isDefault: true,
        isActive: true,
      },
      {
        id: "cat_leisure_hobby",
        name: "취미",
        type: "expense",
        level: "minor",
        parentId: "cat_leisure",
        icon: "🎨",
        sortOrder: 3,
        isDefault: true,
        isActive: true,
      },
      {
        id: "cat_leisure_sports",
        name: "운동",
        type: "expense",
        level: "minor",
        parentId: "cat_leisure",
        icon: "🏃",
        sortOrder: 4,
        isDefault: true,
        isActive: true,
      },
      {
        id: "cat_leisure_subscription",
        name: "구독서비스",
        type: "expense",
        level: "minor",
        parentId: "cat_leisure",
        icon: "📺",
        sortOrder: 5,
        isDefault: true,
        isActive: true,
      },
    ],
  },
  // 교육
  {
    id: "cat_education",
    name: "교육",
    type: "expense",
    level: "major",
    parentId: null,
    icon: "📚",
    sortOrder: 7,
    isDefault: true,
    isActive: true,
    children: [
      {
        id: "cat_education_academy",
        name: "학원",
        type: "expense",
        level: "minor",
        parentId: "cat_education",
        icon: "🏫",
        sortOrder: 1,
        isDefault: true,
        isActive: true,
      },
      {
        id: "cat_education_books",
        name: "도서",
        type: "expense",
        level: "minor",
        parentId: "cat_education",
        icon: "📖",
        sortOrder: 2,
        isDefault: true,
        isActive: true,
      },
      {
        id: "cat_education_lecture",
        name: "강의",
        type: "expense",
        level: "minor",
        parentId: "cat_education",
        icon: "🎓",
        sortOrder: 3,
        isDefault: true,
        isActive: true,
      },
    ],
  },
  // 경조사
  {
    id: "cat_event",
    name: "경조사",
    type: "expense",
    level: "major",
    parentId: null,
    icon: "🎁",
    sortOrder: 8,
    isDefault: true,
    isActive: true,
    children: [
      {
        id: "cat_event_wedding",
        name: "축의금",
        type: "expense",
        level: "minor",
        parentId: "cat_event",
        icon: "💒",
        sortOrder: 1,
        isDefault: true,
        isActive: true,
      },
      {
        id: "cat_event_funeral",
        name: "조의금",
        type: "expense",
        level: "minor",
        parentId: "cat_event",
        icon: "🕯️",
        sortOrder: 2,
        isDefault: true,
        isActive: true,
      },
      {
        id: "cat_event_gift",
        name: "선물",
        type: "expense",
        level: "minor",
        parentId: "cat_event",
        icon: "🎀",
        sortOrder: 3,
        isDefault: true,
        isActive: true,
      },
    ],
  },
  // 금융
  {
    id: "cat_finance",
    name: "금융",
    type: "expense",
    level: "major",
    parentId: null,
    icon: "💰",
    sortOrder: 9,
    isDefault: true,
    isActive: true,
    children: [
      {
        id: "cat_finance_insurance",
        name: "보험",
        type: "expense",
        level: "minor",
        parentId: "cat_finance",
        icon: "🛡️",
        sortOrder: 1,
        isDefault: true,
        isActive: true,
      },
      {
        id: "cat_finance_tax",
        name: "세금",
        type: "expense",
        level: "minor",
        parentId: "cat_finance",
        icon: "📋",
        sortOrder: 2,
        isDefault: true,
        isActive: true,
      },
      {
        id: "cat_finance_interest",
        name: "이자",
        type: "expense",
        level: "minor",
        parentId: "cat_finance",
        icon: "📈",
        sortOrder: 3,
        isDefault: true,
        isActive: true,
      },
      {
        id: "cat_finance_fee",
        name: "수수료",
        type: "expense",
        level: "minor",
        parentId: "cat_finance",
        icon: "💳",
        sortOrder: 4,
        isDefault: true,
        isActive: true,
      },
    ],
  },
  // 기타
  {
    id: "cat_etc",
    name: "기타",
    type: "expense",
    level: "major",
    parentId: null,
    icon: "❓",
    sortOrder: 10,
    isDefault: true,
    isActive: true,
    children: [
      {
        id: "cat_etc_other",
        name: "기타",
        type: "expense",
        level: "minor",
        parentId: "cat_etc",
        icon: "❓",
        sortOrder: 1,
        isDefault: true,
        isActive: true,
      },
    ],
  },
];

// 수입 카테고리
export const incomeCategories: Category[] = [
  {
    id: "cat_salary",
    name: "급여",
    type: "income",
    level: "major",
    parentId: null,
    icon: "💵",
    sortOrder: 1,
    isDefault: true,
    isActive: true,
    children: [
      {
        id: "cat_salary_monthly",
        name: "월급",
        type: "income",
        level: "minor",
        parentId: "cat_salary",
        icon: "💰",
        sortOrder: 1,
        isDefault: true,
        isActive: true,
      },
      {
        id: "cat_salary_bonus",
        name: "보너스",
        type: "income",
        level: "minor",
        parentId: "cat_salary",
        icon: "🎉",
        sortOrder: 2,
        isDefault: true,
        isActive: true,
      },
      {
        id: "cat_salary_incentive",
        name: "상여금",
        type: "income",
        level: "minor",
        parentId: "cat_salary",
        icon: "🏆",
        sortOrder: 3,
        isDefault: true,
        isActive: true,
      },
    ],
  },
  {
    id: "cat_sideincome",
    name: "부수입",
    type: "income",
    level: "major",
    parentId: null,
    icon: "💸",
    sortOrder: 2,
    isDefault: true,
    isActive: true,
    children: [
      {
        id: "cat_sideincome_interest",
        name: "이자",
        type: "income",
        level: "minor",
        parentId: "cat_sideincome",
        icon: "🏦",
        sortOrder: 1,
        isDefault: true,
        isActive: true,
      },
      {
        id: "cat_sideincome_dividend",
        name: "배당",
        type: "income",
        level: "minor",
        parentId: "cat_sideincome",
        icon: "📊",
        sortOrder: 2,
        isDefault: true,
        isActive: true,
      },
      {
        id: "cat_sideincome_refund",
        name: "환급",
        type: "income",
        level: "minor",
        parentId: "cat_sideincome",
        icon: "🔄",
        sortOrder: 3,
        isDefault: true,
        isActive: true,
      },
      {
        id: "cat_sideincome_allowance",
        name: "용돈",
        type: "income",
        level: "minor",
        parentId: "cat_sideincome",
        icon: "🤝",
        sortOrder: 4,
        isDefault: true,
        isActive: true,
      },
    ],
  },
  {
    id: "cat_etc_income",
    name: "기타",
    type: "income",
    level: "major",
    parentId: null,
    icon: "❓",
    sortOrder: 3,
    isDefault: true,
    isActive: true,
    children: [
      {
        id: "cat_etc_income_other",
        name: "기타",
        type: "income",
        level: "minor",
        parentId: "cat_etc_income",
        icon: "❓",
        sortOrder: 1,
        isDefault: true,
        isActive: true,
      },
    ],
  },
];

export const allCategories = [...expenseCategories, ...incomeCategories];

// 헬퍼 함수: ID로 카테고리 찾기
export function findCategoryById(id: string): Category | undefined {
  for (const major of allCategories) {
    if (major.id === id) return major;
    const minor = major.children?.find((c) => c.id === id);
    if (minor) return minor;
  }
  return undefined;
}

// 헬퍼 함수: 대분류 ID로 소분류 목록 가져오기
export function getMinorCategories(majorId: string): Category[] {
  const major = allCategories.find((c) => c.id === majorId);
  return major?.children || [];
}
